import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {MsalService} from "@azure/msal-angular";
import {ModulosFunctions} from "./ModulosFunction";

@Injectable()
export class HibridValidatorService implements CanActivate
{
  constructor(private msalService: MsalService, private model: ModulosFunctions) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
  {
    var accessToken =  localStorage.getItem("accessToken");
    if (!accessToken && this.msalService.instance.getActiveAccount() == null)
    {
      return false;
    }else if (!accessToken && this.msalService.instance.getActiveAccount() != null){
      return this.model.checkUrlModuloInterno(route);
    }else if (accessToken){
      return this.model.checkUrlModuloExterno(route,accessToken);
    }else{
      return false;
    }
  }
}
